































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations, GlobalOverlays } from '@/ts/store/Constants';

@Component({
    components: {},
    computed: {
        ...mapGetters({
            userTicketCurrentType: 'UserTickets/getUserTicketCurrentType',
            userTicketAllCategories: 'UserTickets/getUserTicketAllCategories',
        }),
    },
})
export default class AddNewTicketCategory extends Vue {
    constructor() {
        super();
    }

    get isOpenedLocally() {
        return this.$store.getters['Viewport/getGlobalOverlayWasOpenedLocally'];
    }
    
    public back() {
        this.isOpenedLocally
            ? this.$store.commit(Mutations.SET_GLOBAL_OVERLAY_COMPONENT, GlobalOverlays.TICKET_TYPE)
            : this.$store.commit(Mutations.SET_GLOBAL_OVERLAY_COMPONENT, GlobalOverlays.HOME_ASSISTANT);

        this.$store.commit(Mutations.SET_USER_CURRENT_TICKET_TYPE, []);
        this.$store.commit(Mutations.SET_USER_TICKET_ALL_CATEGORIES, []);
    }
    
    public setNewTicketCategory(categoryId: number) {
        this.$store.dispatch(Actions.FETCH_USER_CURRENT_TICKET_CATEGORY, categoryId);
    }

    public close() {
        this.$store.commit(Mutations.SET_ADD_NEW_TICKET_CATEGORY_VISIBILITY, false);
    }
}
